import { type CSSProperties } from 'react';

// Real lockup PNGs live in client/public/brand/ (served at /brand/).
const FILES: Record<string, string> = {
  'lockup-navy': 'zen-logo-lockup.png',
  'lockup-white': 'zen-logo-lockup-white.png',
  'mark-navy': 'zen-mark.png',
  'mark-white': 'zen-mark-white.png',
  wordmark: 'zen-wordmark.png',
};

export interface LogoProps {
  variant?: 'lockup' | 'mark' | 'wordmark';
  theme?: 'navy' | 'white';
  height?: number | string;
  alt?: string;
  style?: CSSProperties;
}

export function Logo({ variant = 'lockup', theme = 'navy', height = 40, alt = 'Zen Mindware', style }: LogoProps) {
  const key = variant === 'wordmark' ? 'wordmark' : `${variant}-${theme}`;
  const src = `/brand/${FILES[key]}`;
  return (
    <img
      src={src}
      alt={alt}
      style={{ height, width: 'auto', maxWidth: '100%', display: 'block', flex: 'none', objectFit: 'contain', ...style }}
    />
  );
}
